module.exports = __webpack_public_path__ + "static/media/World of Warcraft.d39362b7.mp4";